import classnames from "classnames"
import BackgroundImage from "../background/BackgroundImage"
import ResourceBackground from "../background/ResourceBackground"
import ThemeBackground from "../background/ThemeBackground"
import { useScreensizeContext } from "../ui/Screensize"
import Text from "../ui/Text"
import View from "../ui/View"
import CardBack from "./CardBack"
import "./CardHeader.css"

const CardHeader = ({
  card,
  title,
  meta,
  className,
  image,
  overlay,
  resource,
  children
}) => {
  const screensize = useScreensizeContext()
  const roundedTop = screensize !== "sm"

  return (
    <header className={classnames("CardHeader", className)}>
      {image ? (
        <BackgroundImage
          roundedTop={roundedTop}
          image={image}
          overlay={overlay}
        />
      ) : resource ? (
        <ResourceBackground roundedTop={roundedTop} resource={resource} />
      ) : (
        <ThemeBackground roundedTop={roundedTop} />
      )}
      <View padding className="CardHeader__wrapper">
        <View className="CardHeader__padding">
          <CardBack card={card} inverted />
          <Text.H3 inverted>{title}</Text.H3>
          <Text.Body style={{ marginTop: ".2em" }} inverted>
            {meta}
          </Text.Body>
          {children}
        </View>
      </View>
    </header>
  )
}

CardHeader.displayName = "CardHeader"

export default CardHeader
